import { lazy } from '@cobliteam/lazy-with-retries';

import { Location } from '@cobliteam/common-types';

const DevolutionPage = lazy(
  () => import('@cobliteam/crm/src/pages/DevolutionPage/DevolutionPage')
);

const routes = [
  {
    path: Location.CRM_DEVOLUTION,
    component: DevolutionPage,
  },
];

export default routes;
